











































import { Component, Vue } from 'vue-property-decorator'
import { Mutation, Action } from 'vuex-class'
import { mapState } from 'vuex'
import _PaymentIQ1Click from 'paymentiq-1click-client'
import LoginContent from '@/components/gambling/LoginContent.vue'

@Component({
  components: {
    LoginContent
  },
  computed: {
    ...mapState({
      logInModal: ({ gamblingContext }: any): boolean => gamblingContext.logInModal,
      fullName: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email,
      loginMethod: ({ gamblingContext }: any): boolean => gamblingContext.loginMethod
    })
  }
})

export default class LogInModal extends Vue {
  @Action('loginUserPassword') loginUserPassword: any
  @Mutation('setLogInModal') setLogInModalCommit: any

  private logInModal!: boolean
  private fullName!: null | string
  private email!: null | string

  get getLogInModal (): any {
    return this.logInModal
  }
  set getLogInModal (x: any) {
    this.setLogInModal()
  }

  get logInBtn () {
    return this.fullName && this.email && this.fullName.length > 4 && this.email.length > 5
  }

  setLogInModal () {
    this.setLogInModalCommit(false)
  }
}
